<iframe #iframe width="1920" height="1080" frameborder="0" [style.pointer-events]="disableElementUsage ? 'none' : 'auto'"></iframe>
